import type { SimpleBounds } from '@/types';

export const computePathBounds = (path: [number, number][]): SimpleBounds => {
  let minX = Infinity,
    maxX = -Infinity,
    minY = Infinity,
    maxY = -Infinity;

  for (const p of path) {
    if (p[0] < minX) {
      minX = p[0];
    }

    if (p[0] > maxX) {
      maxX = p[0];
    }

    if (p[1] < minY) {
      minY = p[1];
    }

    if (p[1] > maxY) {
      maxY = p[1];
    }
  }

  return { minX, maxX, minY, maxY };
};
